import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ToasterService } from '../shared/toaster.service';

@Injectable({
  providedIn: 'root',
})
export class selectedPatientGuard implements CanActivate {
  constructor(private toast: ToasterService) { }

  canActivate(): boolean {
    const user = JSON.parse(localStorage.getItem('userDetails') || '{}');
    if (user && user.PatientId) {
      return true;
    }
    this.toast.presentError('','Please select a patient to proceed');
    return false;
  }
}